<template>
  <v-container class="grey lighten-5">
    <h2>{{ company.name }}</h2>
    <br/>
    <v-text-field
        v-model="company.name"
        label="Name der Firma"
        required
    />
    <v-text-field
        v-model="company.location"
        label="Ort"
    />
    <v-text-field
        v-model="company.notificationEmail"
        label="E-Mail (Für Notifications)"
        required
    />
    <v-text-field
        v-model="company.ccPersonsForCertificate"
        label="E-Mails für Zertifikatsversand im CC - bitte mit Komma trennen >> abc@gmail.com, def@gmail.com)"
        required
    />
    <v-switch
        v-model="company.certificatesAdminOnly"
        label="Zertifikate nur für Administratoren"
        hint="Teilnehmer können Zertifikate nicht herunterladen. Neue Zertifikate werden an die Firmen-E-Mail und die CC-Empfänger versandt."
        persistent-hint
    />
    <v-checkbox v-if="superAdmin" v-model="company.trustedCustomer" label="Trusted Customer"/>
    <label>Abteilungen hinzufügen</label>
    <v-combobox
        clearable
        multiple
        outlined
        persistent-hint
        small-chips
        solo
        v-model="company.departments"
        label="Abteilungsname"
    />
    <v-btn
        class="ma-1"
        :loading="loading"
        :disabled="loading"
        color="info"
        @click="save"
    >
      Speichern
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
    <v-alert v-if="nameAlert" style="margin-top: 18px" type="error">Name bitte mit mindestens 3 Buchstaben angeben.
    </v-alert>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>Gespeichert</v-snackbar>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top>
      Ein Fehler ist aufgetreten
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "CompanyEdit",
  props: {
    companyId: {
      type: String
    },
    superAdmin: {
      type: Boolean
    }
  },
  data: () => ({
    company: {name: ""},
    loading: false,
    nameAlert: false,
    success: false,
    error: false,
  }),
  mounted() {
    this.$httpCompanyApi.get(this.companyId, (company) => {
      this.company = company;
    });
  },
  methods: {
    save() {
      if (this.company.name.length < 3) {
        this.loading = false;
        this.nameAlert = true;
      } else {
        this.nameAlert = false;
        this.loading = true;
        if (this.companyId === "-1") {
          this.$httpCompanyApi.create(this.company, () => {
            this.success = true;
            this.loading = false;
            setTimeout(() => this.success = false, 3000);
            this.$emit("finish")
          }, () => {
            this.error = true;
            this.loading = false;
            setTimeout(() => this.error = false, 3000);
          })
        } else {
          this.$httpCompanyApi.update(this.company.id, this.company, () => {
            this.success = true;
            this.loading = false;
            setTimeout(() => this.success = false, 3000);
          }, () => {
            this.error = true;
            this.loading = false;
            setTimeout(() => this.error = false, 3000);
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
